import lockerBookingService from '@/api/lockerbooking'
import { LOCKER_BOOKING } from '../types'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    log: null,
    currentDate: null,
    locationQueryFilter: null,
    queryFilter: null,
    lockersWithBookings: [],
    date: null,
    startTime: null,
    endTime: null,
    location: null,
    selectedLocker: {},
    owners: [],
    loadedFirstTime: false,
    ownerHasChanged: false
  },
  getters:{
    locationQueryFilter: (state) => {
      return state.locationQueryFilter
    },
    queryFilter: (state) => {
      return state.queryFilter
    },
    currentDate: (state) => {
      return state.currentDate
    },
    date: (state) => {
      return state.date
    },
    startTime: (state) => {
      return state.startTime
    },
    endTime: (state) => {
      return state.endTime
    },
    locationId: (state) => {
      return state.location
    },
    selectedLocker: (state) => {
      return state.selectedLocker
    },
    fullStartDate: (state) => {
      const start = state.date + ' ' + state.startTime
      const fullStartDate = proto.$moment(start).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullStartDate
    },
    fullEndDate: (state) => {
      const finish = state.date + ' ' + state.endTime
      const fullEndDate = proto.$moment(finish).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullEndDate
    },
    loadedFirstTime: (state) =>{
      return state.loadedFirstTime
    }
  },
  mutations: {
    [LOCKER_BOOKING.CURRENT_DATE_SET] (state, currentDate) {
      state.currentDate = currentDate
    },
    [LOCKER_BOOKING.LOCKER_BOOKING_SET] (state, lockersWithBookings) {
      state.lockersWithBookings = lockersWithBookings
    },
    [LOCKER_BOOKING.SET_LOCATION_QUERY_FILTER] (state, locationQueryFilter) {
      state.locationQueryFilter = locationQueryFilter
    },
    [LOCKER_BOOKING.SET_QUERY_FILTER] (state, queryFilter) {
      state.queryFilter = queryFilter
    },
    [LOCKER_BOOKING.SET_DATE] (state, date) {
      state.date = date
    },
    [LOCKER_BOOKING.SET_STARTTIME] (state, start) {
      state.startTime = start
    },
    [LOCKER_BOOKING.SET_ENDTIME] (state, end) {
      state.endTime = end
    },
    [LOCKER_BOOKING.SET_LOCATION] (state, location) {
      state.location = location
    },
    [LOCKER_BOOKING.SET_SELECTED_LOCKER] (state, locker) {
      state.selectedLocker = locker
    },
    [LOCKER_BOOKING.SELECT_OWNER] (state, item) {
      state.owners.splice(0, 1)
      state.owners.push(item)
    },
    [LOCKER_BOOKING.REMOVE_OWNER] (state, index) {
      state.owners.splice(index, 1)
    },
    [LOCKER_BOOKING.SET_FULL_STARTDATE] (state, date) {
      state.fullStartDate = date
    },
    [LOCKER_BOOKING.SET_FULL_ENDDATE] (state, date) {
      state.fullEndDate = date
    },
    [LOCKER_BOOKING.SET_LOADED_FIRST_TIME] (state, loadedFirstTime) {
      state.loadedFirstTime = loadedFirstTime
    },
    [LOCKER_BOOKING.SET_OWNER_HAS_CHANGE] (state, ownerHasChanged) {
      state.ownerHasChanged = ownerHasChanged
    }
  },
  actions: {
    setCurrentDate ({commit}, currentDate) {
      commit(LOCKER_BOOKING.CURRENT_DATE_SET, currentDate)
    },
    setFullStartDate ({commit}, fullStartDate) {
      commit(LOCKER_BOOKING.SET_FULL_STARTDATE, fullStartDate)
    },
    setLocationQueryFilter ({commit}, locationQueryFilter) {
      commit(LOCKER_BOOKING.SET_LOCATION_QUERY_FILTER, locationQueryFilter)
    },
    setQueryFilter ({commit}, queryFilter) {
      commit(LOCKER_BOOKING.SET_QUERY_FILTER, queryFilter)
    },
    setDate ({commit}, date) {
      commit(LOCKER_BOOKING.SET_DATE, date)
    },
    setStartTime ({commit}, start) {
      commit(LOCKER_BOOKING.SET_STARTTIME, start)
    },
    setEndTime ({commit}, end) {
      commit(LOCKER_BOOKING.SET_ENDTIME, end)
    },
    setLocation ({commit}, location) {
      commit(LOCKER_BOOKING.SET_LOCATION, location)
    },
    setSelectedLocker ({commit}, locker) {
      commit(LOCKER_BOOKING.SET_SELECTED_LOCKER, locker)
    },
    setLoadedFirstTime ({commit}, loadedFirstTime) {
      commit(LOCKER_BOOKING.SET_LOADED_FIRST_TIME, loadedFirstTime)
    },
    setOwnerHasChanged ({commit}, ownerHasChanged) {
      commit(LOCKER_BOOKING.SET_OWNER_HAS_CHANGE, ownerHasChanged)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(LOCKER_BOOKING.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(LOCKER_BOOKING.REMOVE_OWNER, index)
    },
    clearLockersWithBookings ({commit}){
      commit(LOCKER_BOOKING.LOCKER_BOOKING_SET, [])
    },
    saveBookingOfAnUser ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        const locationId = state.location
        const lockerId = state.selectedLocker.id
        const userEmail = state.owners[0].email
        const start = getters.fullStartDate
        const finish = getters.fullEndDate

        const body = {
          start,
          finish,
          userEmail
        }
        lockerBookingService.saveBookingOfAnUser(locationId, lockerId, body).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    clearFilters: function ({commit}){
      commit(LOCKER_BOOKING.SET_LOCATION_QUERY_FILTER, null)
      commit(LOCKER_BOOKING.SET_QUERY_FILTER, null)
      commit(LOCKER_BOOKING.LOCKER_BOOKING_SET, [])
    },
    deleteBookingOfAnUser: function ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerBookingService.deleteBookingOfAnUser(payload.locker.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    markBookingAsCheckedOutOfAnUser ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerBookingService.markBookingAsCheckedOutOfAnUser(payload.location.id, payload.locker.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    getAllLockersWithTheirBookings({commit, state}) {
      return new Promise((resolve, reject) => {
        const date = proto.$moment(state.currentDate).utc().format()
        lockerBookingService.getAllLockersWithTheirBookings(state.queryFilter, state.locationQueryFilter, date).then((response => {
          commit(LOCKER_BOOKING.LOCKER_BOOKING_SET, response.data)
          resolve()
        })).catch((error) => {
          reject(error)
        })
      })
    },
    markLockerBookingAsCheckedIn ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerBookingService.markBookingAsCheckedIn(payload.locationId, payload.lockerId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    markLockerBookingAsCheckedOut ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerBookingService.markBookingAsCheckedOut(payload.locationId, payload.lockerId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    deleteLockerBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerBookingService.deleteLockerBooking(payload.lockerId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    async createNewBooking({ dispatch }, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const siteId = payload.params.siteId
        const locationId = payload.params.locationId
        const lockerId = payload.params.lockerId
        const filterManageBookingSite = payload.filterManageBookingParams.filterManageBookingSite
        const filterManageBookingLocal = payload.filterManageBookingParams.filterManageBookingLocal

        const response = await lockerBookingService.createNewBooking(locationId, lockerId, payload.body)
        if (siteId === filterManageBookingSite && locationId === filterManageBookingLocal) {
          dispatch('LockerBooking/getAllLockersWithTheirBookings', null, {root: true})
        }
        Promise.resolve(response)
      } catch(error) {
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    }
  }
}
